import { ReleaseList } from 'services/api/entities';
import ReleaseTile from './components/ReleaseTile';
import { StyledReleasesWrapper } from './styled';

interface PropsType {
  data: ReleaseList;
}

const ContentState = ({ data }: PropsType) => (
  <StyledReleasesWrapper>
    {data.releases.map((release) => (
      <ReleaseTile key={release.id} release={release} />
    ))}
  </StyledReleasesWrapper>
);

export default ContentState;
